<template>
  <div class="faq flex justify-center w-full">
    <RequestSupport
      v-if="requestSupport"
      @onCloseSupport="closeSupport"
      @onSendEmail="sendEmail"
    />
    <div
      v-if="!requestSupport"
      class="mt-8 md:mt-32 w-full flex items-center flex-col"
    >

      <div class="content-box mt-8">
        <Accordion class="accordion-faq-custom shadow-md">
          <AccordionTab
            v-for="faq in faqs"
            :key="faq"
            :header="
              $t('labels.generic', { pt: faq.question, en: faq.questionEN })
            "
          >
            <p>
              {{ $t("labels.generic", { pt: faq.answer, en: faq.answerEN }) }}
            </p>
          </AccordionTab>
        </Accordion>
      </div>
      <div
        class="content-box p-8 flex flex-col justify-center sm:justify-start items-center sm:flex-row mt-8 sm:space-x-8 space-y-4 bg-white shadow-md rounded-md border-b-4 border-h-primary-500"
      >
        <img
          src="@/assets/images/virtual-assistant.svg"
          alt="virtual-assistant"
          class="w-1/2 sm:w-32"
        />
        <div class="flex justify-between flex-col space-y-4">
          <div class="space-y-4">
            <h1 class="text-xl font-semibold">
              {{
                $t("labels.generic", {
                  pt: "Não encontrou o que você gostaria?",
                  en: "Didn't find what you'd like?",
                })
              }}
            </h1>
            <p class="text-sm text-gray-500">
              {{
                $t("labels.generic", {
                  pt: "Entre em contato com nosso Suporte, será um prazer ajudá-lo(a).",
                  en: "Contact our Support, it will be a pleasure to help you.",
                })
              }}
            </p>
          </div>
          <button
            class="btn-primary w-full sm:w-1/2 rounded-md"
            @click="requestSupport = true"
          >
            {{
              $t("labels.generic", {
                pt: "Falar com o suporte",
                en: "Talk to support",
              })
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { SupportEmail } from "@/models/support-email.model";
import { SupportEmailRest } from "@/services/rest/email.rest";
import { Messages } from "@/utils/messages.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import { delay } from "rxjs";
import { defineAsyncComponent, defineComponent } from "vue";
import { faqs } from "./faq.util";

const RequestSupport = defineAsyncComponent(
  () => import("./RequestSupport/request-support.vue")
);

export default defineComponent({
  name: "faq",
  components: {
    RequestSupport,
  },
  data() {
    return {
      requestSupport: true as boolean,
      faqs: faqs,
    };
  },
  computed: {
    rest(): SupportEmailRest {
      return new SupportEmailRest();
    },
  },
  mounted() {},
  methods: {
    closeSupport(value: boolean) {
      this.requestSupport = value;
    },
    sendEmail(data: SupportEmail) {
      this.rest
        .sendEmail(data)
        .pipe(delay(500))
        .subscribe({
          next: () => {
            this.$toast.add(ToastFactory.success(Messages.EMAIL_SUCCESS));
            this.closeSupport(false);
          },
          error: (e) => {
            
          },
        });
    },
  },
});
</script>

<style lang="scss" src="./style.scss"></style>
